import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './medallionPreview.module.css';

import FlowConnector from './components/FlowConnector';
import { EDITOR_PREVIEW_SCALE, SCREEN_HEIGHT, SCREEN_WIDTH } from './helper/constants';
import { SAMPLE_PREVIEW_FLOW } from './helper/previewFlow';
import { themeAttrs, themeVars } from './helper/themeVars';
import { SCREEN_COMPONENTS } from './screens';

// `flow` shows the screens as an ordered journey: numbered steps with an arrow between each.
const MedallionPreview = ({
    config,
    logo,
    screens = SAMPLE_PREVIEW_FLOW,
    scale = EDITOR_PREVIEW_SCALE,
    screenCount = screens.length,
    showLabels,
    flow = false,
    className,
}) => (
    <Box
        className={clsx(styles.preview, flow && styles.flow, className)}
        style={{
            ...themeVars(config),
            '--preview-scale': scale,
            '--screen-width': `${SCREEN_WIDTH}px`,
            '--screen-height': `${SCREEN_HEIGHT}px`,
        }}
        {...themeAttrs(config)}
    >
        {screens.slice(0, screenCount).map(({ screen, label, content }, index) => {
            const Screen = SCREEN_COMPONENTS[screen];

            return (
                <React.Fragment key={screen}>
                    {flow && index > 0 && <FlowConnector />}
                    <Box className={styles.item}>
                        <Box className={styles.slot}>
                            <Screen logo={logo} {...content} />
                        </Box>
                        {showLabels && (
                            <Typography className={styles.label}>
                                {flow && <span className={styles.stepNumber}>{index + 1}</span>}
                                {label}
                            </Typography>
                        )}
                    </Box>
                </React.Fragment>
            );
        })}
    </Box>
);

MedallionPreview.propTypes = {
    config: PropTypes.object,
    logo: PropTypes.string,
    screens: PropTypes.arrayOf(
        PropTypes.shape({
            screen: PropTypes.string.isRequired,
            label: PropTypes.string,
            content: PropTypes.object,
        })
    ),
    scale: PropTypes.number,
    screenCount: PropTypes.number,
    showLabels: PropTypes.bool,
    flow: PropTypes.bool,
    className: PropTypes.string,
};

export default MedallionPreview;
